// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - the missing types have to be added into the onedesign-tokens package
import * as oneDesignButtonTokens from '../../onedesign-tokens/dist/js/es6/rem/button';
const buttonTypePrimaryDefaultBorderColorDark = oneDesignButtonTokens.buttonTypePrimaryDefaultBorderColorDark;
const buttonTypePrimaryDefaultBorderColorLight = oneDesignButtonTokens.buttonTypePrimaryDefaultBorderColorLight;
const buttonTypePrimaryDefaultBackgroundColorDark = oneDesignButtonTokens.buttonTypePrimaryDefaultBackgroundColorDark;
const buttonTypePrimaryDefaultBackgroundColorLight = oneDesignButtonTokens.buttonTypePrimaryDefaultBackgroundColorLight;
const buttonTypePrimaryDefaultTextColorDark = oneDesignButtonTokens.buttonTypePrimaryDefaultTextColorDark;
const buttonTypePrimaryDefaultTextColorLight = oneDesignButtonTokens.buttonTypePrimaryDefaultTextColorLight;
const buttonTypePrimaryHoverBorderColorDark = oneDesignButtonTokens.buttonTypePrimaryHoverBorderColorDark;
const buttonTypePrimaryHoverBorderColorLight = oneDesignButtonTokens.buttonTypePrimaryHoverBorderColorLight;
const buttonTypePrimaryHoverBackgroundColorDark = oneDesignButtonTokens.buttonTypePrimaryHoverBackgroundColorDark;
const buttonTypePrimaryHoverBackgroundColorLight = oneDesignButtonTokens.buttonTypePrimaryHoverBackgroundColorLight;
const buttonTypePrimaryHoverTextColorDark = oneDesignButtonTokens.buttonTypePrimaryHoverTextColorDark;
const buttonTypePrimaryHoverTextColorLight = oneDesignButtonTokens.buttonTypePrimaryHoverTextColorLight;
const buttonTypePrimaryActiveBorderColorDark = oneDesignButtonTokens.buttonTypePrimaryActiveBorderColorDark;
const buttonTypePrimaryActiveBorderColorLight = oneDesignButtonTokens.buttonTypePrimaryActiveBorderColorLight;
const buttonTypePrimaryActiveBackgroundColorDark = oneDesignButtonTokens.buttonTypePrimaryActiveBackgroundColorDark;
const buttonTypePrimaryActiveBackgroundColorLight = oneDesignButtonTokens.buttonTypePrimaryActiveBackgroundColorLight;
const buttonTypePrimaryActiveTextColorDark = oneDesignButtonTokens.buttonTypePrimaryActiveTextColorDark;
const buttonTypePrimaryActiveTextColorLight = oneDesignButtonTokens.buttonTypePrimaryActiveTextColorLight;
const buttonTypePrimaryFocusOutline = oneDesignButtonTokens.buttonTypePrimaryFocusOutline;
const buttonTypeSecondaryDefaultBorderColorDark = oneDesignButtonTokens.buttonTypeSecondaryDefaultBorderColorDark;
const buttonTypeSecondaryDefaultBorderColorLight = oneDesignButtonTokens.buttonTypeSecondaryDefaultBorderColorLight;
const buttonTypeSecondaryDefaultBackgroundColorDark = oneDesignButtonTokens.buttonTypeSecondaryDefaultBackgroundColorDark;
const buttonTypeSecondaryDefaultBackgroundColorLight = oneDesignButtonTokens.buttonTypeSecondaryDefaultBackgroundColorLight;
const buttonTypeSecondaryDefaultTextColorDark = oneDesignButtonTokens.buttonTypeSecondaryDefaultTextColorDark;
const buttonTypeSecondaryDefaultTextColorLight = oneDesignButtonTokens.buttonTypeSecondaryDefaultTextColorLight;
const buttonTypeSecondaryHoverBorderColorDark = oneDesignButtonTokens.buttonTypeSecondaryHoverBorderColorDark;
const buttonTypeSecondaryHoverBorderColorLight = oneDesignButtonTokens.buttonTypeSecondaryHoverBorderColorLight;
const buttonTypeSecondaryHoverBackgroundColorDark = oneDesignButtonTokens.buttonTypeSecondaryHoverBackgroundColorDark;
const buttonTypeSecondaryHoverBackgroundColorLight = oneDesignButtonTokens.buttonTypeSecondaryHoverBackgroundColorLight;
const buttonTypeSecondaryHoverTextColorDark = oneDesignButtonTokens.buttonTypeSecondaryHoverTextColorDark;
const buttonTypeSecondaryHoverTextColorLight = oneDesignButtonTokens.buttonTypeSecondaryHoverTextColorLight;
const buttonTypeSecondaryActiveBorderColorDark = oneDesignButtonTokens.buttonTypeSecondaryActiveBorderColorDark;
const buttonTypeSecondaryActiveBorderColorLight = oneDesignButtonTokens.buttonTypeSecondaryActiveBorderColorLight;
const buttonTypeSecondaryActiveBackgroundColorDark = oneDesignButtonTokens.buttonTypeSecondaryActiveBackgroundColorDark;
const buttonTypeSecondaryActiveBackgroundColorLight = oneDesignButtonTokens.buttonTypeSecondaryActiveBackgroundColorLight;
const buttonTypeSecondaryActiveTextColorDark = oneDesignButtonTokens.buttonTypeSecondaryActiveTextColorDark;
const buttonTypeSecondaryActiveTextColorLight = oneDesignButtonTokens.buttonTypeSecondaryActiveTextColorLight;
const buttonTypeSecondaryFocusOutline = oneDesignButtonTokens.buttonTypeSecondaryFocusOutline;
const buttonTypeTertiaryDefaultBorderColorDark = oneDesignButtonTokens.buttonTypeTertiaryDefaultBorderColorDark;
const buttonTypeTertiaryDefaultBorderColorLight = oneDesignButtonTokens.buttonTypeTertiaryDefaultBorderColorLight;
const buttonTypeTertiaryDefaultBackgroundColorDark = oneDesignButtonTokens.buttonTypeTertiaryDefaultBackgroundColorDark;
const buttonTypeTertiaryDefaultBackgroundColorLight = oneDesignButtonTokens.buttonTypeTertiaryDefaultBackgroundColorLight;
const buttonTypeTertiaryDefaultTextColorDark = oneDesignButtonTokens.buttonTypeTertiaryDefaultTextColorDark;
const buttonTypeTertiaryDefaultTextColorLight = oneDesignButtonTokens.buttonTypeTertiaryDefaultTextColorLight;
const buttonTypeTertiaryHoverBorderColorDark = oneDesignButtonTokens.buttonTypeTertiaryHoverBorderColorDark;
const buttonTypeTertiaryHoverBorderColorLight = oneDesignButtonTokens.buttonTypeTertiaryHoverBorderColorLight;
const buttonTypeTertiaryHoverBackgroundColorDark = oneDesignButtonTokens.buttonTypeTertiaryHoverBackgroundColorDark;
const buttonTypeTertiaryHoverBackgroundColorLight = oneDesignButtonTokens.buttonTypeTertiaryHoverBackgroundColorLight;
const buttonTypeTertiaryHoverTextColorDark = oneDesignButtonTokens.buttonTypeTertiaryHoverTextColorDark;
const buttonTypeTertiaryHoverTextColorLight = oneDesignButtonTokens.buttonTypeTertiaryHoverTextColorLight;
const buttonTypeTertiaryActiveBorderColorDark = oneDesignButtonTokens.buttonTypeTertiaryActiveBorderColorDark;
const buttonTypeTertiaryActiveBorderColorLight = oneDesignButtonTokens.buttonTypeTertiaryActiveBorderColorLight;
const buttonTypeTertiaryActiveBackgroundColorDark = oneDesignButtonTokens.buttonTypeTertiaryActiveBackgroundColorDark;
const buttonTypeTertiaryActiveBackgroundColorLight = oneDesignButtonTokens.buttonTypeTertiaryActiveBackgroundColorLight;
const buttonTypeTertiaryActiveTextColorDark = oneDesignButtonTokens.buttonTypeTertiaryActiveTextColorDark;
const buttonTypeTertiaryActiveTextColorLight = oneDesignButtonTokens.buttonTypeTertiaryActiveTextColorLight;
const buttonTypeTertiaryFocusOutline = oneDesignButtonTokens.buttonTypeTertiaryFocusOutline;
const buttonDisabledCursor = oneDesignButtonTokens.buttonDisabledCursor;
const buttonDisabledOpacity = oneDesignButtonTokens.buttonDisabledOpacity;
export const focusColor = 'hsla(196, 100%, 43%, 1)';
export const darkBlue = {
    95: 'hsl(223, 67%, 95%)',
    90: 'hsl(223, 67%, 90%)',
    85: 'hsl(223, 67%, 85%)',
    80: 'hsl(223, 67%, 80%)',
    75: 'hsl(223, 67%, 75%)',
    70: 'hsl(223, 67%, 70%)',
    65: 'hsl(223, 67%, 65%)',
    60: 'hsl(223, 67%, 60%)',
    55: 'hsl(223, 67%, 55%)',
    50: 'hsl(223, 67%, 50%)',
    45: 'hsl(223, 67%, 45%)',
    40: 'hsl(223, 67%, 40%)',
    35: 'hsl(223, 67%, 35%)',
    30: 'hsl(223, 67%, 30%)',
    25: 'hsl(223, 67%, 25%)',
    18: 'hsl(223, 67%, 18%)',
    15: 'hsl(223, 67%, 15%)',
    10: 'hsl(223, 67%, 10%)',
    5: 'hsl(223, 67%, 5%)',
    main: 'hsl(223, 67%, 18%)'
};
export const digiGreen = {
    95: 'hsl(139, 100%, 95%)',
    90: 'hsl(139, 100%, 90%)',
    85: 'hsl(139, 100%, 85%)',
    80: 'hsl(139, 100%, 80%)',
    78: 'hsl(139, 100%, 78%)',
    70: 'hsl(139, 100%, 70%)',
    65: 'hsl(139, 100%, 65%)',
    60: 'hsl(139, 100%, 60%)',
    55: 'hsl(139, 100%, 55%)',
    50: 'hsl(139, 100%, 50%)',
    45: 'hsl(139, 100%, 45%)',
    40: 'hsl(139, 100%, 40%)',
    35: 'hsl(139, 100%, 35%)',
    30: 'hsl(139, 100%, 30%)',
    25: 'hsl(139, 100%, 25%)',
    20: 'hsl(139, 100%, 20%)',
    15: 'hsl(139, 100%, 15%)',
    10: 'hsl(139, 100%, 10%)',
    5: 'hsl(139, 100%, 5%)',
    main: 'hsl(139, 100%, 78%)'
};
export const earth = {
    95: 'hsl(35, 53%, 95%)',
    89: 'hsl(35, 53%, 89%)',
    85: 'hsl(35, 53%, 85%)',
    80: 'hsl(35, 53%, 80%)',
    75: 'hsl(35, 53%, 75%)',
    70: 'hsl(35, 53%, 70%)',
    65: 'hsl(35, 53%, 65%)',
    60: 'hsl(35, 53%, 60%)',
    55: 'hsl(35, 53%, 55%)',
    50: 'hsl(35, 53%, 50%)',
    45: 'hsl(35, 53%, 45%)',
    40: 'hsl(35, 53%, 40%)',
    35: 'hsl(35, 53%, 35%)',
    30: 'hsl(35, 53%, 30%)',
    25: 'hsl(35, 53%, 25%)',
    20: 'hsl(35, 53%, 20%)',
    15: 'hsl(35, 53%, 15%)',
    10: 'hsl(35, 53%, 10%)',
    5: 'hsl(35, 53%, 5%)',
    main: 'hsl(35, 53%, 89%)'
};
export const energyRed = {
    95: 'hsl(357, 83%, 95%)',
    90: 'hsl(357, 83%, 90%)',
    85: 'hsl(357, 83%, 85%)',
    80: 'hsl(357, 83%, 80%)',
    75: 'hsl(357, 83%, 75%)',
    70: 'hsl(357, 83%, 70%)',
    65: 'hsl(357, 83%, 65%)',
    60: 'hsl(357, 83%, 60%)',
    54: 'hsl(357, 83%, 54%)',
    50: 'hsl(357, 83%, 50%)',
    45: 'hsl(357, 83%, 45%)',
    40: 'hsl(357, 83%, 40%)',
    35: 'hsl(357, 83%, 35%)',
    30: 'hsl(357, 83%, 30%)',
    25: 'hsl(357, 83%, 25%)',
    20: 'hsl(357, 83%, 20%)',
    15: 'hsl(357, 83%, 15%)',
    10: 'hsl(357, 83%, 10%)',
    5: 'hsl(357, 83%, 5%)',
    main: 'hsl(357, 83%, 54%)'
};
export const landGreen = {
    95: 'hsl(114, 49%, 95%)',
    90: 'hsl(114, 49%, 90%)',
    85: 'hsl(114, 49%, 85%)',
    80: 'hsl(114, 49%, 80%)',
    75: 'hsl(114, 49%, 75%)',
    70: 'hsl(114, 49%, 70%)',
    65: 'hsl(114, 49%, 65%)',
    60: 'hsl(114, 49%, 60%)',
    55: 'hsl(114, 49%, 55%)',
    50: 'hsl(114, 49%, 50%)',
    45: 'hsl(114, 49%, 45%)',
    41: 'hsl(114, 49%, 41%)',
    35: 'hsl(114, 49%, 35%)',
    30: 'hsl(114, 49%, 30%)',
    25: 'hsl(114, 49%, 25%)',
    20: 'hsl(114, 49%, 20%)',
    15: 'hsl(114, 49%, 15%)',
    10: 'hsl(114, 49%, 10%)',
    5: 'hsl(114, 49%, 5%)',
    main: 'hsl(114, 49%, 41%)'
};
export const seaBlue = {
    95: 'hsl(218, 100%, 95%)',
    90: 'hsl(218, 100%, 90%)',
    85: 'hsl(218, 100%, 85%)',
    80: 'hsl(218, 100%, 80%)',
    75: 'hsl(218, 100%, 75%)',
    70: 'hsl(218, 100%, 70%)',
    65: 'hsl(218, 100%, 65%)',
    60: 'hsl(218, 100%, 60%)',
    55: 'hsl(218, 100%, 55%)',
    50: 'hsl(218, 100%, 55%)',
    45: 'hsl(218, 100%, 45%)',
    40: 'hsl(218, 100%, 40%)',
    35: 'hsl(218, 100%, 35%)',
    28: 'hsl(218, 100%, 28%)',
    25: 'hsl(218, 100%, 25%)',
    20: 'hsl(218, 100%, 20%)',
    15: 'hsl(218, 100%, 15%)',
    10: 'hsl(218, 100%, 10%)',
    5: 'hsl(218, 100%, 5%)',
    main: 'hsl(218, 100%, 28%)'
};
export const sandstone = {
    95: 'hsl(40, 3%, 95%)',
    90: 'hsl(40, 3%, 90%)',
    85: 'hsl(40, 3%, 85%)',
    79: 'hsl(40, 3%, 79%)',
    75: 'hsl(40, 3%, 75%)',
    70: 'hsl(40, 3%, 70%)',
    65: 'hsl(40, 3%, 65%)',
    60: 'hsl(40, 3%, 60%)',
    55: 'hsl(40, 3%, 55%)',
    50: 'hsl(40, 3%, 50%)',
    45: 'hsl(40, 3%, 45%)',
    40: 'hsl(40, 3%, 40%)',
    35: 'hsl(40, 3%, 35%)',
    30: 'hsl(40, 3%, 30%)',
    25: 'hsl(40, 3%, 25%)',
    20: 'hsl(40, 3%, 20%)',
    15: 'hsl(40, 3%, 15%)',
    10: 'hsl(40, 3%, 10%)',
    5: 'hsl(40, 3%, 5%)',
    main: 'hsl(40, 3%, 79%)'
};
export const skyBlue = {
    97: 'hsl(196, 74%, 97%)',
    95: 'hsl(196, 74%, 95%)',
    90: 'hsl(196, 74%, 90%)',
    85: 'hsl(196, 74%, 85%)',
    80: 'hsl(196, 74%, 80%)',
    77: 'hsl(196, 74%, 77%)',
    65: 'hsl(196, 74%, 65%)',
    60: 'hsl(196, 74%, 60%)',
    55: 'hsl(196, 74%, 55%)',
    50: 'hsl(196, 74%, 50%)',
    45: 'hsl(196, 74%, 45%)',
    40: 'hsl(196, 74%, 40%)',
    35: 'hsl(196, 74%, 35%)',
    30: 'hsl(196, 74%, 30%)',
    25: 'hsl(196, 74%, 25%)',
    20: 'hsl(196, 74%, 20%)',
    15: 'hsl(196, 74%, 15%)',
    10: 'hsl(196, 74%, 10%)',
    5: 'hsl(196, 74%, 5%)',
    main: 'hsl(196, 74%, 77%)',
    active: 'hsl(196, 74%, 95%)',
    hover: 'hsl(196, 74%, 90%)',
    selected: 'hsl(196, 74%, 95%)' // skyBlue.95
};
export const sunflower = {
    95: 'hsl(55, 100%, 95%)',
    90: 'hsl(55, 100%, 90%)',
    85: 'hsl(55, 100%, 85%)',
    80: 'hsl(55, 100%, 80%)',
    73: 'hsl(55, 100%, 73%)',
    70: 'hsl(55, 100%, 70%)',
    65: 'hsl(55, 100%, 65%)',
    60: 'hsl(55, 100%, 60%)',
    55: 'hsl(55, 100%, 55%)',
    50: 'hsl(55, 100%, 50%)',
    45: 'hsl(55, 100%, 45%)',
    40: 'hsl(55, 100%, 40%)',
    35: 'hsl(55, 100%, 35%)',
    30: 'hsl(55, 100%, 30%)',
    25: 'hsl(55, 100%, 25%)',
    20: 'hsl(55, 100%, 20%)',
    15: 'hsl(55, 100%, 15%)',
    10: 'hsl(55, 100%, 10%)',
    5: 'hsl(55, 100%, 5%)',
    main: 'hsl(55, 100%, 73%)'
};
export const terracotta = {
    95: 'hsl(34, 100%, 95%)',
    90: 'hsl(34, 100%, 90%)',
    85: 'hsl(34, 100%, 85%)',
    80: 'hsl(34, 100%, 80%)',
    75: 'hsl(34, 100%, 75%)',
    70: 'hsl(34, 100%, 70%)',
    65: 'hsl(34, 100%, 65%)',
    60: 'hsl(34, 100%, 60%)',
    55: 'hsl(34, 100%, 55%)',
    50: 'hsl(34, 100%, 50%)',
    45: 'hsl(34, 100%, 45%)',
    40: 'hsl(34, 100%, 40%)',
    35: 'hsl(34, 100%, 35%)',
    30: 'hsl(34, 100%, 30%)',
    25: 'hsl(34, 100%, 25%)',
    20: 'hsl(34, 100%, 20%)',
    15: 'hsl(34, 100%, 15%)',
    10: 'hsl(34, 100%, 10%)',
    5: 'hsl(34, 100%, 5%)',
    main: 'hsl(34, 100%, 35%)'
};
export const warmGrey = {
    95: 'hsl(30, 8%, 95%)',
    90: 'hsl(30, 8%, 90%)',
    85: 'hsl(30, 8%, 85%)',
    80: 'hsl(30, 8%, 80%)',
    75: 'hsl(30, 8%, 75%)',
    70: 'hsl(30, 8%, 70%)',
    65: 'hsl(30, 8%, 65%)',
    60: 'hsl(30, 8%, 60%)',
    56: 'hsl(30, 8%, 56%)',
    50: 'hsl(30, 8%, 50%)',
    45: 'hsl(30, 8%, 45%)',
    40: 'hsl(30, 8%, 40%)',
    35: 'hsl(30, 8%, 35%)',
    30: 'hsl(30, 8%, 30%)',
    25: 'hsl(30, 8%, 25%)',
    20: 'hsl(30, 8%, 20%)',
    15: 'hsl(30, 8%, 15%)',
    10: 'hsl(30, 8%, 10%)',
    5: 'hsl(30, 8%, 5%)',
    main: 'hsl(30, 8%, 56%)'
};
export const blue = {
    10: '#f6fbff',
    20: '#e2f1ff',
    30: '#c2e1fe',
    40: '#a1cef9',
    50: '#77baf9',
    60: '#48a1f3',
    70: '#1e86e5',
    80: '#0067c5',
    90: '#075094',
    100: '#003f79'
};
export const green = {
    10: '#efffed',
    20: '#d8ffd3',
    30: '#bdfbb6',
    40: '#9df291',
    50: '#82db77',
    60: '#68c35e',
    70: '#4ea344',
    80: '#36842d',
    90: '#276121',
    100: '#024019'
};
export const grey = {
    10: '#f7f8f9',
    20: '#f1f3f5',
    30: '#e1e6e9',
    40: '#c3ccd3',
    50: '#a5b3bd',
    60: '#8799a7',
    70: '#768b9c',
    80: '#698091',
    90: '#586c7a',
    100: '#465663'
};
export const pink = {
    10: '#fff3fd',
    20: '#ffddf9',
    30: '#ffbdf3',
    40: '#ff8eea',
    50: '#ff55df',
    60: '#ff0ed2',
    70: '#ee00c1',
    80: '#da00b1',
    90: '#a00082',
    100: '#72005c'
};
export const prussian = {
    10: '#eff3f5',
    20: '#c5dce8',
    30: '#91bbcf',
    40: '#5690ac',
    50: '#32718e',
    60: '#0d5071',
    70: '#003b57',
    80: '#002a3e',
    90: '#001620',
    100: '#000b11'
};
export const red = {
    10: '#fff1f1',
    20: '#ffe4e4',
    30: '#ffc8c8',
    40: '#faa7ab',
    50: '#fb7b81',
    60: '#f64d55',
    70: '#e84148',
    80: '#d6383f',
    90: '#b62f3a',
    100: '#962730'
};
export const yellow = {
    10: '#fffde7',
    20: '#fff8bd',
    30: '#ffed7a',
    40: '#ffe43a',
    50: '#ffd600',
    60: '#fec600',
    70: '#f4b40d',
    80: '#e29c13',
    90: '#b67b08',
    100: '#83591a'
};
export const disabled = {
    bg: sandstone[95],
    border: sandstone[10],
    color: sandstone[10]
};
export default {
    buttonTypePrimaryDefaultBorderColorDark,
    buttonTypePrimaryDefaultBackgroundColorDark,
    buttonTypePrimaryDefaultTextColorDark,
    buttonTypePrimaryHoverBackgroundColorDark,
    buttonTypePrimaryHoverBorderColorDark,
    buttonTypePrimaryHoverTextColorDark,
    buttonTypePrimaryActiveBackgroundColorDark,
    buttonTypePrimaryActiveBorderColorDark,
    buttonTypePrimaryActiveTextColorDark,
    buttonTypePrimaryDefaultBorderColorLight,
    buttonTypePrimaryDefaultBackgroundColorLight,
    buttonTypePrimaryDefaultTextColorLight,
    buttonTypePrimaryFocusOutline,
    buttonTypePrimaryHoverBackgroundColorLight,
    buttonTypePrimaryHoverBorderColorLight,
    buttonTypePrimaryHoverTextColorLight,
    buttonTypePrimaryActiveBackgroundColorLight,
    buttonTypePrimaryActiveBorderColorLight,
    buttonTypePrimaryActiveTextColorLight,
    buttonTypeSecondaryDefaultBorderColorDark,
    buttonTypeSecondaryDefaultBackgroundColorDark,
    buttonTypeSecondaryDefaultTextColorDark,
    buttonTypeSecondaryFocusOutline,
    buttonTypeSecondaryHoverBackgroundColorDark,
    buttonTypeSecondaryHoverBorderColorDark,
    buttonTypeSecondaryHoverTextColorDark,
    buttonTypeSecondaryActiveBackgroundColorDark,
    buttonTypeSecondaryActiveBorderColorDark,
    buttonTypeSecondaryActiveTextColorDark,
    buttonTypeSecondaryDefaultBorderColorLight,
    buttonTypeSecondaryDefaultBackgroundColorLight,
    buttonTypeSecondaryDefaultTextColorLight,
    buttonTypeSecondaryHoverBackgroundColorLight,
    buttonTypeSecondaryHoverBorderColorLight,
    buttonTypeSecondaryHoverTextColorLight,
    buttonTypeSecondaryActiveBackgroundColorLight,
    buttonTypeSecondaryActiveBorderColorLight,
    buttonTypeSecondaryActiveTextColorLight,
    buttonTypeTertiaryDefaultBorderColorDark,
    buttonTypeTertiaryDefaultBackgroundColorDark,
    buttonTypeTertiaryDefaultTextColorDark,
    buttonTypeTertiaryHoverBackgroundColorDark,
    buttonTypeTertiaryHoverBorderColorDark,
    buttonTypeTertiaryHoverTextColorDark,
    buttonTypeTertiaryFocusOutline,
    buttonTypeTertiaryActiveBackgroundColorDark,
    buttonTypeTertiaryActiveBorderColorDark,
    buttonTypeTertiaryActiveTextColorDark,
    buttonTypeTertiaryDefaultBorderColorLight,
    buttonTypeTertiaryDefaultBackgroundColorLight,
    buttonTypeTertiaryDefaultTextColorLight,
    buttonTypeTertiaryHoverBackgroundColorLight,
    buttonTypeTertiaryHoverBorderColorLight,
    buttonTypeTertiaryHoverTextColorLight,
    buttonTypeTertiaryActiveBackgroundColorLight,
    buttonTypeTertiaryActiveBorderColorLight,
    buttonTypeTertiaryActiveTextColorLight,
    buttonDisabledCursor,
    buttonDisabledOpacity,
    darkBlue,
    digiGreen,
    earth,
    energyRed,
    focusColor,
    landGreen,
    sandstone,
    seaBlue,
    skyBlue,
    sunflower,
    terracotta,
    warmGrey,
    blue,
    green,
    grey,
    pink,
    prussian,
    red,
    yellow,
    disabled
};
